module.exports = __webpack_public_path__ + "static/media/drvm-active.4f37be88.png";